import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBringBack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.6667 2.5H4.16667C3.2475 2.5 2.5 3.2475 2.5 4.16667V11.6667C2.5 12.5858 3.2475 13.3333 4.16667 13.3333H6.66667V15.8333C6.66667 16.7525 7.41417 17.5 8.33333 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V8.33333C17.5 7.41417 16.7525 6.66667 15.8333 6.66667H13.3333V4.16667C13.3333 3.2475 12.5858 2.5 11.6667 2.5ZM4.16667 4.16667H11.6667L11.6642 11.6667H4.16667V4.16667Z",
		fill: "#363F5A"
	})]
});
const ForwardRef = forwardRef(SvgBringBack);
export default ForwardRef;
